/**
 * Sprouties PDP Redesign JavaScript
 * January 2025 - Enhanced subscription widget with 2025 UX best practices
 */

(function() {
  'use strict';

  /**
   * Format price in AED (cents to display)
   */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return 'AED ' + amount;
  }

  /**
   * Subscription Widget - Complete redesign with subscribe-first UX
   * Features:
   * - Subscribe pre-selected by default
   * - Visual feedback for all states
   * - Frequency selector always visible when subscribed
   * - Dynamic price updates
   * - Form integration with Shopify selling plans
   */
  function initSubscriptionWidget() {
    try {
      const widget = document.getElementById('subscriptionWidget');
      if (!widget) return;

      const sectionId = widget.dataset.sectionId;
      if (!sectionId) {
        console.warn('[Sprouties Widget] Missing section ID');
        return;
      }

    // Get elements
    const purchaseTypeInputs = widget.querySelectorAll('input[name="purchase_type_' + sectionId + '"]');
    const frequencySection = document.getElementById('frequencySelector');
    const frequencyInputs = widget.querySelectorAll('input[name="frequency_' + sectionId + '"]');
    const sellingPlanInput = document.getElementById('sellingPlanInput_' + sectionId);
    const singlePlanInput = widget.querySelector('[data-single-plan]');

    // Widget display elements
    const subscribeDisplay = widget.querySelector('[data-subscribe-display]');
    const compareDisplay = widget.querySelector('[data-compare-display]');
    const badgeEl = widget.querySelector('.subscription-widget__badge');

    // Find the product form and ensure it has selling_plan input
    const form = document.querySelector('form[data-type="add-to-cart-form"]') ||
                 document.querySelector('form[action*="/cart/add"]') ||
                 document.querySelector('.product-form form');

    let formSellingPlanInput = form ? form.querySelector('input[name="selling_plan"]') : null;

    if (form && !formSellingPlanInput) {
      formSellingPlanInput = document.createElement('input');
      formSellingPlanInput.type = 'hidden';
      formSellingPlanInput.name = 'selling_plan';
      formSellingPlanInput.value = '';
      form.appendChild(formSellingPlanInput);
    }

    /**
     * Update the selling_plan value in all relevant inputs
     */
    function setSellingPlan(planId) {
      if (sellingPlanInput) sellingPlanInput.value = planId || '';
      if (formSellingPlanInput) formSellingPlanInput.value = planId || '';



      // Update any other selling_plan inputs in the form
      if (form) {
        const allSellingPlanInputs = form.querySelectorAll('input[name="selling_plan"]');
        allSellingPlanInputs.forEach(function(input) {
          input.value = planId || '';
        });
      }
    }

    /**
     * Update the subscribe card display when frequency changes
     */
    function updateSubscribeCardDisplay(planPrice, planDiscount, comparePrice) {
      if (subscribeDisplay) {
        subscribeDisplay.textContent = formatMoney(planPrice);
      }
      if (compareDisplay) {
        compareDisplay.textContent = formatMoney(comparePrice);
      }
      if (badgeEl) {
        if (planDiscount > 0) {
          badgeEl.textContent = 'SAVE ' + planDiscount + '%';
          badgeEl.style.display = '';
        } else {
          badgeEl.style.display = 'none';
        }
      }
    }

    /**
     * Get plan data from selected frequency or single plan
     */
    function getSelectedPlanData() {
      const oneTimePrice = parseInt(widget.dataset.oneTimePrice, 10) || 0;

      if (singlePlanInput) {
        return {
          planId: singlePlanInput.value,
          price: parseInt(singlePlanInput.dataset.planPrice, 10) || oneTimePrice,
          discount: parseInt(singlePlanInput.dataset.planDiscount, 10) || 0,
          comparePrice: oneTimePrice
        };
      }

      const checkedFrequency = widget.querySelector('input[name="frequency_' + sectionId + '"]:checked');
      if (checkedFrequency) {
        const label = checkedFrequency.closest('label');
        if (!label) {
          return { planId: '', price: oneTimePrice, discount: 0, comparePrice: oneTimePrice };
        }
        return {
          planId: checkedFrequency.value,
          price: parseInt(label.dataset.planPrice, 10) || oneTimePrice,
          discount: parseInt(label.dataset.planDiscount, 10) || 0,
          comparePrice: parseInt(label.dataset.planCompare, 10) || oneTimePrice
        };
      }

      return {
        planId: '',
        price: oneTimePrice,
        discount: 0,
        comparePrice: oneTimePrice
      };
    }

    /**
     * Handle purchase type toggle (One-Time vs Subscribe)
     */
    function onPurchaseTypeChange(e) {
      const value = e.target.value;
      const oneTimePrice = parseInt(widget.dataset.oneTimePrice, 10) || 0;

      if (value === 'subscribe') {
        // Show frequency selector if exists
        if (frequencySection) {
          frequencySection.style.display = '';
        }

        // Get selected plan data and update
        const planData = getSelectedPlanData();
        setSellingPlan(planData.planId);
        updateSubscribeCardDisplay(planData.price, planData.discount, planData.comparePrice);

      } else {
        // One-Time selected
        if (frequencySection) {
          frequencySection.style.display = 'none';
        }
        setSellingPlan('');
      }
    }

    /**
     * Handle frequency change
     */
    function onFrequencyChange(e) {
      const label = e.target.closest('label');
      if (!label) return;

      const planId = e.target.value;
      const planPrice = parseInt(label.dataset.planPrice, 10) || 0;
      const planDiscount = parseInt(label.dataset.planDiscount, 10) || 0;
      const comparePrice = parseInt(label.dataset.planCompare, 10) || parseInt(widget.dataset.oneTimePrice, 10) || 0;

      setSellingPlan(planId);
      updateSubscribeCardDisplay(planPrice, planDiscount, comparePrice);
    }

    // Attach event listeners
    purchaseTypeInputs.forEach(function(input) {
      input.addEventListener('change', onPurchaseTypeChange);
    });

    frequencyInputs.forEach(function(input) {
      input.addEventListener('change', onFrequencyChange);
    });

    // Initialize state based on what's currently selected
    const subscribeChecked = widget.querySelector('input[value="subscribe"]:checked');
    const oneTimeChecked = widget.querySelector('input[value="one-time"]:checked');

    if (subscribeChecked) {
      // Subscribe is selected - set up the form
      const planData = getSelectedPlanData();
      setSellingPlan(planData.planId);

      // Ensure frequency selector is visible
      if (frequencySection) {
        frequencySection.style.display = '';
      }

      // Update display with correct prices
      if (planData.discount > 0) {
        updateSubscribeCardDisplay(planData.price, planData.discount, planData.comparePrice);
      }
    } else if (oneTimeChecked) {
      // One-Time is selected
      setSellingPlan('');
      if (frequencySection) {
        frequencySection.style.display = 'none';
      }
    } else {
      // Nothing selected - default to subscribe (per UX best practices)
      const subscribeRadio = widget.querySelector('input[value="subscribe"]');
      if (subscribeRadio) {
        subscribeRadio.checked = true;
        const planData = getSelectedPlanData();
        setSellingPlan(planData.planId);
        if (frequencySection) {
          frequencySection.style.display = '';
        }
      }
    }

    // Listen for Shopify section events (theme customizer)
    document.addEventListener('shopify:section:load', function() {
      initSubscriptionWidget();
    });

    } catch (error) {
      console.error('[Sprouties Widget] Initialization failed:', error);
    }
  }

  /**
   * Accordion Enhancement - Smooth animations
   */
  function initAccordions() {
    const accordionItems = document.querySelectorAll('.card-widget--is-accordion-item');

    accordionItems.forEach(function(item) {
      const header = item.querySelector('.card-widget__header');
      const content = item.querySelector('.toggle__content');

      if (!header || !content) return;

      // Add smooth transition
      content.style.transition = 'max-height 0.3s ease-out';

      // Watch for toggle changes
      const toggle = item.querySelector('.toggle');
      if (toggle) {
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'class') {
              const isOpen = toggle.classList.contains('opened');
              if (isOpen) {
                content.style.maxHeight = content.scrollHeight + 'px';
              } else {
                content.style.maxHeight = '0';
              }
            }
          });
        });

        observer.observe(toggle, { attributes: true });
      }
    });
  }

  /**
   * Benefits Grid - Scroll reveal animation
   */
  function initBenefitsGrid() {
    const cards = document.querySelectorAll('.benefits-grid__card');

    if (cards.length === 0 || !('IntersectionObserver' in window)) return;

    // Add initial hidden state
    cards.forEach(function(card, index) {
      card.style.opacity = '0';
      card.style.transform = 'translateY(20px)';
      card.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
      card.style.transitionDelay = (index * 100) + 'ms';
    });

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    cards.forEach(function(card) {
      observer.observe(card);
    });

    // Respect reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      cards.forEach(function(card) {
        card.style.opacity = '1';
        card.style.transform = 'none';
        card.style.transition = 'none';
      });
    }
  }

  /**
   * Happy Cats Counter - Animated count-up on scroll
   */
  function initHappyCatsCounter() {
    const counter = document.getElementById('happyCatsNumber');
    if (!counter) return;

    const target = parseInt(counter.dataset.target, 10) || 2847;
    const duration = 1500;
    let started = false;

    function easeOutQuart(x) {
      return 1 - Math.pow(1 - x, 4);
    }

    function animateCounter() {
      if (started) return;
      started = true;

      const startTime = performance.now();

      function updateCounter(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = easeOutQuart(progress);
        const current = Math.floor(easedProgress * target);

        counter.textContent = current.toLocaleString();

        if (progress < 1) {
          requestAnimationFrame(updateCounter);
        }
      }

      requestAnimationFrame(updateCounter);
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          animateCounter();
          observer.disconnect();
        }
      }, { threshold: 0.5 });

      observer.observe(counter);
    } else {
      counter.textContent = target.toLocaleString();
    }
  }

  /**
   * Review Quote Rotator - Rotating testimonials
   */
  function initReviewQuoteRotator() {
    const quotes = [
      { text: "Luna won't stop munching!", author: "Sarah", location: "Dubai" },
      { text: "Finally, grass my cats actually eat", author: "Ahmed", location: "Abu Dhabi" },
      { text: "Freshest grass we've ever tried", author: "Maria", location: "Sharjah" },
      { text: "My picky cat approved!", author: "Fatima", location: "Dubai" },
      { text: "So much healthier than store-bought", author: "Omar", location: "Ajman" }
    ];

    let currentIndex = 0;
    const textEl = document.getElementById('quoteText');
    const authorEl = document.getElementById('quoteAuthor');
    const locationEl = document.getElementById('quoteLocation');
    const container = document.getElementById('reviewQuote');

    if (!textEl || !authorEl || !locationEl || !container) return;

    let intervalId = null;

    function rotateQuote() {
      container.style.opacity = '0';

      setTimeout(function() {
        currentIndex = (currentIndex + 1) % quotes.length;
        const quote = quotes[currentIndex];
        textEl.textContent = quote.text;
        authorEl.textContent = quote.author;
        locationEl.textContent = quote.location;
        container.style.opacity = '1';
      }, 300);
    }

    intervalId = setInterval(rotateQuote, 5000);

    // Clean up on page navigation (for SPAs)
    document.addEventListener('visibilitychange', function() {
      if (document.hidden && intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      } else if (!document.hidden && !intervalId) {
        intervalId = setInterval(rotateQuote, 5000);
      }
    });
  }

  /**
   * Harvested Date Badge - Shows tomorrow's date
   */
  function initHarvestedDateBadge() {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const options = { weekday: 'short', month: 'short', day: 'numeric' };
    const formatted = tomorrow.toLocaleDateString('en-AE', options);

    const harvestEl = document.getElementById('harvestDate');
    const arrivalEl = document.getElementById('arrivalDate');

    if (harvestEl) harvestEl.textContent = formatted;
    if (arrivalEl) arrivalEl.textContent = formatted;
  }

  /**
   * Initialize all components when DOM is ready
   */
  function init() {
    initSubscriptionWidget();
    initAccordions();
    initBenefitsGrid();
    initHappyCatsCounter();
    initReviewQuoteRotator();
    initHarvestedDateBadge();

    console.log('[Sprouties PDP Redesign] All components initialized');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
